var ATLAlerts = (function() {

    var alertsWrapper = `
        <div class='box-content alerts'>{0}</div>
    `;

    var messageWrapper = `
        <div class='alert alert-{0} alert-dismissible'>
            <button class='close' data-dismiss='alert'>&times;</button>
            {1}
        </div>`;

    function formatMessage(message)
    {
        var args = Array.prototype.slice.call(arguments, 1);
        return message.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    }

    function addAlert(status, message)
    {
        const alert = formatMessage(messageWrapper, status, message);

        const storedMessagesString = localStorage.getItem("flash_messages");
        let messages = [];
        if (storedMessagesString) {
            messages = JSON.parse(storedMessagesString);
        }
        messages.push(alert);
        localStorage.setItem("flash_messages", JSON.stringify(messages));
    }

    function getAlerts()
    {
        let messages = localStorage.getItem("flash_messages");
        if (!messages) {
            return [];
        }

        return JSON.parse(messages);
    }

    function clearAlerts()
    {
        localStorage.setItem("flash_messages", JSON.stringify([]));
    }

    function formatAPIException(exception) {
        let response = exception.responseJSON;
        if (response == null) return 'A technical error has occured. Please contact us for more details.';

        if (response.message) return response.message;
        if (response.status) return response.status;

        return 'A technical error has occured. Please contact us for more details.'; 
    }

    return {
        addSuccess : function(message)
        {
            addAlert("success", message);
        },
        addError : function(message)
        {
            addAlert("error", message);
        },
        addWarning : function(message)
        {
            addAlert("warning", message);
        },
        formatAPIException : function(exception) {
            return formatAPIException(exception);
        },
        displayAlerts: function(withWrapper = true)
        {
            let alerts = getAlerts();
            if (alerts.length == 0) // no alert
            {
                return '';
            }

            clearAlerts();

            let alertsHTML = '';
            alerts.forEach((alert) => {
                alertsHTML += alert;
            });

            if (withWrapper) {
                alertsHTML = formatMessage(alertsWrapper, alertsHTML);
            }

            return alertsHTML;
        }
    }
})();